unit f_visiteinserisci;

{$mode objfpc}

interface

uses
  Classes, SysUtils, js, web, un_widget, un_tquery, w_table, un_generator, f_selezione, un_user;
type

  { TFrmVisiteInserisci }

  TFrmVisiteInserisci = class(TWidget)
    nuovorecord :String;
    procedure AfterRender; override;
    procedure AfterDomAppend; async; override;
    procedure salva_click(Event: TJSEvent); async;
    procedure chiudi_click(Event: TJSEvent); async;

  private

  published
    procedure idfruitore_click; async;
    procedure idfruitore2_click; async;
    QrySeleziona: TQuery;
    QryVisite: TQuery;
    dtdata: TJSHTMLInputElement;
    horaarrivo: TJSHTMLInputElement;
    idfruitore: TJSHTMLInputElement;
    dsfruitore: TJSHTMLInputElement;
    dsindirizzopartenza: TJSHTMLInputElement;
    dstelefono: TJSHTMLInputElement;
    dsnote: TJSHTMLInputElement;
    idfruitore2: TJSHTMLInputElement;
    dsfruitore2: TJSHTMLInputElement;
    dsindirizzoarrivo: TJSHTMLInputElement;

  end;

implementation

{$R *.html}

{ TFrmVisiteInserisci }

procedure TFrmVisiteInserisci.AfterRender;
begin

 //

end;

procedure TFrmVisiteInserisci.AfterDomAppend;
begin

//

end;

procedure TFrmVisiteInserisci.salva_click(Event: TJSEvent);
var
  NuovoID: Integer;
  DataVisita: String;
  IDUtente: String;
  IDFruitoreSQL: String;
  IDFruitore2SQL: String;
begin
  // 1. Validazione campi obbligatori
  if Trim(dtdata.value) = '' then
  begin
    ShowMessage('La data è obbligatoria');
    Exit;
  end;

  if Trim(horaarrivo.value) = '' then
  begin
    ShowMessage('L''ora è obbligatoria');
    Exit;
  end;

  try
    // 2. Recupero nuovo ID
    NuovoID := await(GetNextId('TA_TRASPORTI'));

    // 3. Data nel formato YYYY-MM-DD
    DataVisita := Copy(dtdata.value, 1, 10);

    // 4. ID fruitore
    // Se non è stato selezionato, inserisco NULL
    if Trim(idfruitore.value) = '' then
      IDFruitoreSQL := 'NULL'
    else
      IDFruitoreSQL := idfruitore.value;

    // 5. ID secondo fruitore
    // Se non è stato selezionato, inserisco NULL
    if Trim(idfruitore2.value) = '' then
      IDFruitore2SQL := 'NULL'
    else
      IDFruitore2SQL := idfruitore2.value;

    // 6. Recupero ID utente
    if (user.QryUtenti.Active) and
       (not user.QryUtenti.IsEmpty) then
      IDUtente :=
        user.QryUtenti.FieldByName('idutente').AsString
    else
      IDUtente := 'COMUNE';

    // 7. Costruzione INSERT
    QryVisite.SQL.Text :=
        'INSERT INTO TA_TRASPORTI ('
      + 'IDTRASPORTO, '
      + 'IDSOCIETA, '
      + 'DTDATA, '
      + 'HORAARRIVO, '
      + 'IDFRUITORE, '
      + 'DSFRUITORE, '
      + 'DSINDIRIZZOPARTENZA, '
      + 'DSTELEFONO, '
      + 'DSNOTE, '
      + 'IDFRUITORE2, '
      + 'DSFRUITORE2, '
      + 'DSINDIRIZZOARRIVO, '
      + 'IDTIPORICHIESTA, '
      + 'DSTIPORICHIESTA, '
      + 'FLPROVVISORIO, '
      + 'DSSTATO, '
      + 'IDUTENTE, '
      + 'IDENTERICHIEDENTE, '
      + 'DSENTERICHIEDENTE, '
      + 'DTINSERIMENTO'
      + ') VALUES ('
      + IntToStr(NuovoID) + ', '
      + QuotedStr('DON001') + ', '
      + 'DATE ' + QuotedStr(DataVisita) + ', '
      + QuotedStr(horaarrivo.value) + ', '

      // IDFRUITORE
      + IDFruitoreSQL + ', '

      + QuotedStr(dsfruitore.value) + ', '
      + QuotedStr(dsindirizzopartenza.value) + ', '
      + QuotedStr(dstelefono.value) + ', '
      + QuotedStr(dsnote.value) + ', '

      // IDFRUITORE2
      + IDFruitore2SQL + ', '

      + QuotedStr(dsfruitore2.value) + ', '
      + QuotedStr(dsindirizzoarrivo.value) + ', '

      + '5, '
      + QuotedStr('Visite') + ', '
      + QuotedStr('P') + ', '
      + QuotedStr('EFFETTUATO') + ', '
      + QuotedStr(IDUtente) + ', '

      // Ente richiedente
      + '45, '
      + QuotedStr('Comune di Gussago') + ', '

      // Data inserimento
      + 'CURRENT_DATE'

      + ')';

    // 8. Esecuzione INSERT
    await(QryVisite.ExecuteSql);

    // 9. Conferma
    ShowMessage(
      'Visita salvata con successo (ID: ' +
      IntToStr(NuovoID) + ')'
    );

    Close();

  except
    on E: Exception do
    begin
      ShowMessage(
        'Errore Database: ' +
        E.Message
      );
    end;
  end;
end;

procedure TFrmVisiteInserisci.chiudi_click(Event: TJSEvent);
begin

  Close;

end;

procedure TFrmVisiteInserisci.idfruitore_click;
begin
  
  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= ' select idanagrafica, dsragionesociale, '
       + ' dsindirizzo ||'' - ''|| dslocalita ||'' - ''|| dsprovincia as indirizzo, '
       + ' dstelefono, dsnote '
       + ' from an_anagrafiche ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      idfruitore.value := QrySeleziona.FieldByName('idanagrafica').AsString;
      dsfruitore.value := QrySeleziona.FieldByName('dsragionesociale').AsString;
      dsindirizzopartenza.value := QrySeleziona.FieldByName('indirizzo').AsString;
      dstelefono.value := QrySeleziona.FieldByName('dstelefono').AsString;
      dsnote.value := QrySeleziona.FieldByName('dsnote').AsString;
    end;
  end;

end;

procedure TFrmVisiteInserisci.idfruitore2_click;
begin

  with TFrmSelezione.Create do
  begin
    OpenQrySeleziona := procedure async
    begin
      CloseForm := True;
      QrySeleziona.Close;
      QrySeleziona.SQL.Text:= ' select idanagrafica, dsragionesociale, '
       + ' dsindirizzo ||'' - ''|| dslocalita ||'' - ''|| dsprovincia as indirizzo '
       + ' from an_anagrafiche ';
      AWait(QrySeleziona.Open);
    end;

    if AWait(Show) = mrOK then
    begin
      idfruitore2.value := QrySeleziona.FieldByName('idanagrafica').AsString;
      dsfruitore2.value := QrySeleziona.FieldByName('dsragionesociale').AsString;
      dsindirizzoarrivo.value := QrySeleziona.FieldByName('indirizzo').AsString;
    end;
  end;

end;

initialization
  RegisterWeb(TFrmVisiteInserisci);

end.

